/*
Monotype Foundry Platform API
Version 1.0.0

Definition: DropShipFilesRequest

Properties:
  files: array (required)
*/

var DropShipFilesRequest = (function () {
  function validateDropShipFilesRequest (arg) {
    // Validate files
    if (!arg.files) {
      throw new Error('DropShipFilesRequest.files: Missing property')
    }
    if (arg.files && !(Array.isArray(arg.files))) {
      throw new Error('DropShipFilesRequest.files: Wrong type: Got \'' + (typeof arg.files) + '\', but expected: \'array\'')
    }
  }
  function buildDropShipFilesRequest (arg) {
    var DropShipFilesRequest = arg
    // Complete files
    // Expected Type: array
    DropShipFilesRequest.files = DropShipFilesRequest.files || []
    return DropShipFilesRequest
  }
  return {
    validate: validateDropShipFilesRequest,
    build: buildDropShipFilesRequest
  }
})()

module.exports = DropShipFilesRequest
